export default __webpack_public_path__ + "static/media/SB-BIOLOGY-HIGH-SCHOOL-AP-U5.cb6d7024.jpg";